import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import type { FileUIPart } from 'ai';

import { Button, Icons, Theme } from 'baukasten';

import messages from './messages';
import { companionUrl } from '../utils/companionRequest';
import { fileNames } from '../utils/messageParts';

const DownloadButton = styled(Button)`
  margin-bottom: ${Theme.getBaseUnit(2)};
`;

const COMPANION_DOWNLOAD_PATH = /^\/download\/[\w-]+$/;

type Props = { file: FileUIPart };

/** Only a file from the Companion's own download path becomes a button. */
export const DownloadChip = ({ file }: Props) => {
  const { formatMessage } = useIntl();
  const { title, filename } = fileNames(file);
  const label = title ?? filename ?? formatMessage(messages.download);

  if (!COMPANION_DOWNLOAD_PATH.test(file.url)) return null;

  // cross-origin anchors ignore `download`, so open a tab and let Content-Disposition decide
  const handleDownload = () => {
    const anchor = document.createElement('a');
    anchor.href = companionUrl(file.url);
    anchor.target = '_blank';
    anchor.rel = 'noopener';
    anchor.click();
  };

  return (
    <DownloadButton
      type="button"
      color="primary"
      variant="contained"
      startIcon={Icons.Export}
      onClick={handleDownload}
    >
      {label}
    </DownloadButton>
  );
};
